import React from 'react';
import { Dashboard } from '@/components/admin/Dashboard';

export const AdminDashboard: React.FC = () => {
  return <Dashboard />;
};
